<!-- TimetableHeader.vu e
  座席予約表の縦列の表題の集合を保持するコンテナ
--> 
<template lang="html">
  <table id="timetableHeader" :style="getStyle">
    <thead>
      <ruler-header classroom=""></ruler-header>
      <timeline-header
      v-for="classroom in filteredclassroomNames"
      :key="classroom.name"
      :classroom="classroom.name"></timeline-header>
    </thead>
  </table>
</template>

<script>
import TimelineHeader from './TimelineHeader'
import RulerHeader from './RulerHeader'
import {
  mapActions,
  mapGetters
} from 'vuex'

export default {
  name: 'timetable-header',
  data () {
    return {
      classroom: '',
      lastOnlineState: false
    }
  },
  props: [
    'classrooms'
  ],
  components: {
    'timeline-header': TimelineHeader,
    'ruler-header': RulerHeader
  },
  computed: {
    ...mapGetters([
      'classroomNames',
      'tableWidth'
    ]),
    getStyle () {
      const style = {}
      style.width = this.tableWidth + 'px'
      if (this.$window.scrollY > 0) {
        style.position = 'absolute'
        style.top = this.$window.scrollY + 50 + 'px'
        style['z-index'] = 1003
        style['border-top-style'] = 'solid'
        style['border-top-width'] = '2px'
        style['border-top-color'] = 'black'
      }
      return style
    },
    filteredclassroomNames () { // computedだが、なぜか毎フレーム呼ばれる（原因調査中）
      // 一旦教室情報を再取得
      if (this.lastOnlineState !== this.$store.state.showOnline) {
        console.log('getting classrooms')
        this.getClassrooms(this.$store.state.userInfo.school_id)
      }
      this.classroom = this.$store.state.classrooms
      this.lastOnlineState = this.$store.state.showOnline
      if (this.$store.state.showOnline) {
        this.classroom = this.classroom.filter(function (c) {
          return c.name.match(/^オンライン/)
        })
      } else {
        this.classroom = this.classroom.filter(function (c) {
          return !c.name.match(/^オンライン/)
        })
      }
      if (this.$store.state.userInfo.user_type !== 'viewer' && this.$store.state.userInfo.user_id !== 18 && this.$store.state.userInfo.user_type !== 'admin') {
        this.classroom = this.classroom.filter(function (c) {
          return !c.name.match('301')
        })
        this.$store.state.classrooms = this.classroom
        return this.classroom
      }
      this.$store.state.classrooms = this.classroom
      return this.classroom
    }
  },
  methods: {
    ...mapActions([
      'getClassrooms',
      'getReservations'
    ])
  }
}
</script>

<style lang="css" scoped>
#timetableHeader{
  box-sizing: border-box;
  width: auto;
  z-index: 1001;
  /*table-layout: fixed;*/
}

thead {
  box-sizing: border-box;
  margin-left: -1px;
}
</style>



// WEBPACK FOOTER //
// TimetableHeader.vue?44557bcc